import styled from "@emotion/styled";
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../../components/services/api";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useEffect } from "react";
import { useParams } from "react-router";
import moment from "moment";

export default function AttachFile() {
  const Input = styled("input")({
    display: "none",
  });
  const [FileData, setFileData] = useState([]);
  const [RemarkFile, setRemarkFile] = useState("");
  const [myFile, setMyFile] = useState([]);
  const [type, setType] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [url, setUrl] = useState("");
  async function init() {
    const response = await fetch("/resources/config.json");
    const results = await response.json();
    setUrl(results);
  }
  const getMyFile = async () => {
    const params = {
      id: "",
      uploadType: 2,
    };
    try {
      const data = await api.get(`api/repair/detail/attachfile/${id}`);
      setMyFile(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const handleFileUpload = () => {
    setLoading(true);
    let formData = new FormData();
    for (const key in FileData) formData.append("FileUpload", FileData[key]);
    formData.append("RepairContainerId", id);
    // formData.append("uploadType", 2);

    // formData.append("createId", EmpId);
    formData.append("Remark", RemarkFile);
    formData.append("Type", type);

    // console.log(fileData);
    // console.log(formData);

    api
      .post("api/repair/update/attachfile/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire("สำเร็จ!", "เพิ่ม ไฟล์ สำเร็จ !", "success");
        });
        setFileData([]);
        setRemarkFile("");
        getMyFile();
        setLoading(false);
        // console.log(res);
      })
      .catch(() => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "error",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire("ล้มเหลว!", "เพิ่ม ไฟล์ ไม่สำเร็จ !", "error");
        });
        setFileData([]);
        setRemarkFile("");
        getMyFile();
      });
  };
  useEffect(() => {
    getMyFile();
    init();
  }, []);

  return (
    <>
      <h5 style={{ marginTop: "10px" }} className="textcolordarkblue">
        อัพโหลดสำเนาเอกสาร
      </h5>
      <br />
      <label>
        (ไฟล์ที่ยอมรับ .pdf, .doc , .xls, .xlsx, .txt, .jpeg, .png )
      </label>
      <div style={{ marginTop: 10 }}>
        <label htmlFor="contained-button-file">
          <Input
            accept="application/doc,application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/png, image/jpeg, .txt"
            id="contained-button-file"
            multiple
            type="file"
            onChange={(e) => {
              if (e.target.files) {
                setFileData([...FileData, ...e.target.files]);
              } else {
                const MySwal = withReactContent(Swal);

                MySwal.fire(
                  "กรุณาตรวจสอบไฟล์!",
                  "กรุณาเลือกไฟล์อัพโหลด .PDF .DOC .XLS .XLSX .JPEG .PNG เท่านั้น !",
                  "info"
                );
              }
              // console.log(e.target.files[0]);
            }}
          />
          <Button variant="contained" color="primary" component="span">
            เลือกเอกสารที่ต้องการอัพโหลด
          </Button>
          {FileData?.map((item) => {
            return (
              <Button
                variant="contained"
                color="primary"
                component="span"
                sx={{ marginLeft: "10px" }}
              >
                {item?.name != undefined
                  ? item?.name
                  : "เลือกเอกสารที่ต้องการอัพโหลด"}
              </Button>
            );
          })}
        </label>
      </div>
      <div style={{ display: "flex", marginTop: 10 }}>
        {FileData.length > 0 ? (
          <>
            <FormControl sx={{ width: "40%", marginRight: "10px" }}>
              <InputLabel>
                Type <font color="red">*</font>
              </InputLabel>
              <Select
                label="Type "
                value={type}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setType(e.target.value)}
              >
                <MenuItem value="Before Repair">Before Repair</MenuItem>
                <MenuItem value="After Repair">After Repair</MenuItem>

                <MenuItem value="INVOICE">INVOICE</MenuItem>
              </Select>
            </FormControl>
            <TextField
              name="remarkFile"
              label="Remark *"
              variant="outlined"
              placeholder="Remark *"
              onChange={(e) => setRemarkFile(e.target.value)}
              style={{ width: "40%", marginRight: 10 }}
              InputLabelProps={{ shrink: true }}
              value={RemarkFile}
            />
            {loading ? (
              <CircularProgress size={26} />
            ) : (
              <Button
                variant="contained"
                style={{ width: "20%" }}
                color="success"
                component="span"
                disabled={type ? false : true}
                onClick={handleFileUpload}
              >
                <FileUploadIcon /> Upload
              </Button>
            )}
          </>
        ) : null}
      </div>
      <div>
        {/* {myFile?.length > 0 ? ( */}
        <div>
          <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
            {" "}
            ไฟล์ของคุณ
          </h6>
          <TableContainer
            sx={{
              marginTop: 2,
              marginBottom: 2,
              maxHeight: "50vh",
              overflow: "auto",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center" width="5%">
                    #
                  </TableCell>
                  <TableCell align="center" width="15%">
                    type
                  </TableCell>
                  <TableCell align="center" width="15%">
                    ชื่อไฟล์
                  </TableCell>
                  <TableCell align="center" width="15%">
                    user
                  </TableCell>
                  <TableCell align="center" width="15%">
                    date
                  </TableCell>
                  <TableCell align="center" width="25%">
                    remark
                  </TableCell>
                  <TableCell align="center" width="10%">
                    ลบ
                  </TableCell>
                </TableRow>
              </TableHead>
              {myFile?.map((data, index) => {
                return (
                  <TableBody key={index}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">{data?.Type}</TableCell>
                    <TableCell align="center">
                      <a
                        href={url.REACT_APP_BASE_API + data?.FilePath}
                        target="_blank"
                      >
                        {data?.FileName}
                      </a>
                    </TableCell>
                    <TableCell align="center">{data?.EmployeeName}</TableCell>
                    <TableCell align="center">
                      {moment(data?.CreateDate).format("DD/MM/yyyy")}
                    </TableCell>
                    <TableCell align="center">{data?.Remark}</TableCell>

                    <TableCell align="center">
                      <Button
                        variant="contained"
                        style={{
                          color: "white",
                          backgroundColor: "#FF0000",
                        }}
                        onClick={async () => {
                          const MySwal = withReactContent(Swal);
                          MySwal.fire({
                            title: "คุณกำลังลบไฟล์?",
                            text: "คุณกำลังต้องการที่จะลบไฟล์ใช่หรือไม่!",
                            icon: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "ใช่ !",
                            cancelButtonText: "ไม่",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              const params = {
                                FileId: data?.FileID,
                                RepairContainerId: id,
                              };
                              api
                                .post(
                                  "api/repair/update/attachfile/delete",
                                  params
                                )
                                .then((respose) => {
                                  const MySwal = withReactContent(Swal);

                                  MySwal.fire({
                                    icon: "success",
                                    didOpen: () => {
                                      MySwal.clickConfirm();
                                    },
                                  }).then(() => {
                                    return MySwal.fire(
                                      "สำเร็จ!",
                                      "ลบไฟล์สำเร็จ !",
                                      "success"
                                    );
                                  });
                                  getMyFile();
                                });
                            }
                          });
                        }}
                      >
                        ลบ
                      </Button>
                    </TableCell>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
        </div>
        {/* ) : null} */}
      </div>
    </>
  );
}
